import { SVGAttributes } from 'react'

export const GiphyMark = (props: SVGAttributes<SVGSVGElement>) => (
    <svg viewBox="0 0 28 35" aria-hidden="true" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path fill="#000" d="M4 4h20v27H4z" />
            <path fill="#00ff99" d="M0 3h4v29H0z" />
            <path fill="#9933ff" d="M24 11h4v21h-4z" />
            <path fill="#00ccff" d="M0 31h28v4H0z" />
            <path fill="#fff35c" d="M0 0h16v4H0z" />
            <path fill="#ff6666" d="M24 8V4h-4V0h-4v12h12V8" />
            <path fill="#000" d="M24 16v-4h4M16 0v4h-4" opacity=".4" />
        </g>
    </svg>
)

export const GiphyWordmark = (props: SVGAttributes<SVGSVGElement>) => (
    <svg viewBox="38 0 126 35" aria-label="GIPHY" {...props}>
        <g fill="#fff" fillRule="nonzero">
            <path d="M149.427 13.3l5.84-9.333h8.636v.35l-10.77 16.002V31.15h-7.665V20.32L135.165 4.277v-.311h8.635zM125.249 31.189V20.903h-9.76v10.286h-7.666V4.006h7.665V14.33h9.76V4.006h7.588v27.183zM88.593 23.82v7.33h-7.665V3.967h13.176c7.277 0 10.886 4.589 10.886 9.897 0 5.561-3.648 9.858-10.886 9.936h-5.51v.02zm0-6.495h5.511c2.135 0 3.221-1.556 3.221-3.344 0-1.79-1.125-3.423-3.221-3.423h-5.51v6.767zM68.567 31.15V3.967h7.626V31.15h-7.626zM59.389 12.017c-1.98-1.867-4.386-2.373-6.19-2.373-4.424 0-7.277 2.645-7.277 7.953 0 3.5 1.824 7.797 7.277 7.797 1.436 0 3.687-.272 5.24-1.4v-3.5h-6.85v-6.008h13.253v12.075c-1.708 3.461-6.423 5.328-11.663 5.328-10.73 0-14.805-7.175-14.805-14.292 0-7.097 4.657-14.408 14.844-14.408 3.765 0 7.083.778 10.653 4.394l-4.482 4.434z" />
        </g>
    </svg>
)
